/**
 * Deprecated module: moved from curves/abstract/utils.js to curves/utils.js
 * @module
 */
import * as u from "../utils.js";
/** @deprecated moved to `@noble/curves/utils.js` */
export const abytes = u.abytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const anumber = u.anumber;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bytesToHex = u.bytesToHex;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bytesToUtf8 = u.bytesToUtf8;
/** @deprecated moved to `@noble/curves/utils.js` */
export const concatBytes = u.concatBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const hexToBytes = u.hexToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const isBytes = u.isBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const randomBytes = u.randomBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const utf8ToBytes = u.utf8ToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const abool = u.abool;
/** @deprecated moved to `@noble/curves/utils.js` */
export const numberToHexUnpadded = u.numberToHexUnpadded;
/** @deprecated moved to `@noble/curves/utils.js` */
export const hexToNumber = u.hexToNumber;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bytesToNumberBE = u.bytesToNumberBE;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bytesToNumberLE = u.bytesToNumberLE;
/** @deprecated moved to `@noble/curves/utils.js` */
export const numberToBytesBE = u.numberToBytesBE;
/** @deprecated moved to `@noble/curves/utils.js` */
export const numberToBytesLE = u.numberToBytesLE;
/** @deprecated moved to `@noble/curves/utils.js` */
export const numberToVarBytesBE = u.numberToVarBytesBE;
/** @deprecated moved to `@noble/curves/utils.js` */
export const ensureBytes = u.ensureBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const equalBytes = u.equalBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const copyBytes = u.copyBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const asciiToBytes = u.asciiToBytes;
/** @deprecated moved to `@noble/curves/utils.js` */
export const inRange = u.inRange;
/** @deprecated moved to `@noble/curves/utils.js` */
export const aInRange = u.aInRange;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bitLen = u.bitLen;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bitGet = u.bitGet;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bitSet = u.bitSet;
/** @deprecated moved to `@noble/curves/utils.js` */
export const bitMask = u.bitMask;
/** @deprecated moved to `@noble/curves/utils.js` */
export const createHmacDrbg = u.createHmacDrbg;
/** @deprecated moved to `@noble/curves/utils.js` */
export const notImplemented = u.notImplemented;
/** @deprecated moved to `@noble/curves/utils.js` */
export const memoized = u.memoized;
/** @deprecated moved to `@noble/curves/utils.js` */
export const validateObject = u.validateObject;
/** @deprecated moved to `@noble/curves/utils.js` */
export const isHash = u.isHash;
//# sourceMappingURL=utils.js.map